import { useEffect, useRef, useState } from "react";

import { Button } from "@design-system/Button/Button";
import { DateRangePicker } from "@design-system/DateRangePicker/DateRangePicker";

import {
  type DashboardDateRange,
  formatDashboardRangeLabel,
} from "./formatDashboardRange";
import classes from "./DashboardRangeControl.module.css";

type Props = {
  value: DashboardDateRange;
  onChange: (range: DashboardDateRange) => void;
};

export const DashboardRangeControl = ({ value, onChange }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handlePointerDown = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
    };
  }, [isOpen]);

  return (
    <div className={classes.container} ref={containerRef}>
      <Button
        variant="outlined"
        color="secondary"
        size="sm"
        icon="faCalendar"
        aria-expanded={isOpen}
        aria-label="Date range"
        onClick={() => setIsOpen((open) => !open)}
      >
        {formatDashboardRangeLabel(value)}
      </Button>
      {isOpen ? (
        <div className={classes.popover}>
          <DateRangePicker value={value} onChange={onChange} />
        </div>
      ) : null}
    </div>
  );
};
